module.exports = __webpack_public_path__ + "media/images/pc/stores/common/appeal_01-bc62ab6ccca6810f9db709bc4a29274f.jpg";